import api from "utils/api";

// Get all referrals with filters and pagination
export const getAllReferrals = async (params = {}) => {
  try {
    const response = await api.get("/referrals", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get referral by ID
export const getReferralById = async (id) => {
  try {
    const response = await api.get(`/referrals/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Create referral (admin only - for existing users)
export const createReferral = async (data) => {
  try {
    const response = await api.post("/referrals", data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Update referral
export const updateReferral = async (id, data) => {
  try {
    const response = await api.put(`/referrals/${id}`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Delete referral
export const deleteReferral = async (id) => {
  try {
    const response = await api.delete(`/referrals/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Process redeem request (approve/decline)
export const processRedeemRequest = async (id, formData) => {
  try {
    const response = await api.put(`/referrals/${id}/process`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Get referral statistics
export const getReferralStats = async () => {
  try {
    const response = await api.get("/referrals/stats");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Upload file to get URL
export const uploadFile = async (file) => {
  try {
    const formData = new FormData();
    formData.append("screenShot", file);
    const response = await api.post("/referrals/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Verify referral
export const verifyReferral = async (id) => {
  try {
    const response = await api.put(`/referrals/${id}/verify`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
// Get referral settings
export const getReferralSettings = async () => {
  try {
    const response = await api.get("/referrals/settings");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Update referral settings
export const updateReferralSettings = async (data) => {
  try {
    const response = await api.put("/referrals/settings", data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// Reset referral settings to default values
export const resetReferralSettings = async () => {
  try {
    const response = await api.post("/referrals/settings/reset");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};